import { Box, Typography, Stepper, Step, StepLabel, StepConnector } from '@mui/material';
import { CustomStepperStyles } from '../../../../../components/Styles';
import { buildFineStatusData } from '../Model/Model';

/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */
const CustomStepIcon = ({ step }) => {
    if (!step?.icon) return null;
    const Icon = step.icon.type;
    return <Icon fill={step.backgroundColor} className='custom-step-icon' />;
};

export const FineStatusStepper = (
    {
        statusId,
        statusScheduleId,
        finePaymentDate,
        createdAtFine,
        discountDate,
        paymentDate,
        suspendedAccountDate,
        discountApplied,
        t
    }
) => {
    const steps = buildFineStatusData(
        statusId, statusScheduleId, createdAtFine, finePaymentDate,
        discountDate, paymentDate, suspendedAccountDate, discountApplied
    );

    return (
        <Box>
            <Stepper
                sx={CustomStepperStyles.stepperContainer}
                alternativeLabel
                connector={<StepConnector sx={CustomStepperStyles.connector} />}
            >
                {steps.map((step, index) => (
                    <Step key={index}>
                        <StepLabel StepIconComponent={(props) => <CustomStepIcon {...props} step={step} />}>
                            <div className='d-flex flex-column align-items-center gap-1'>
                                <Typography variant='caption' sx={CustomStepperStyles.statusText(step?.titleColor)}>
                                    {t(step.status)}
                                </Typography>
                                <Typography variant='caption' sx={CustomStepperStyles.dateText(step?.subtitleColor)}>
                                    {step.date}
                                </Typography>
                            </div>
                        </StepLabel>
                    </Step>
                ))}
            </Stepper>
        </Box>
    );
};


export default FineStatusStepper;
